export default __webpack_public_path__ + "SmileyMeh.00958a86.svg";